<template>
  <div class="tab-content flex-grow-1 overflow-auto" id="myTabContent">
    <div
      class="tab-pane fade bg-dark h-100 active show"
      id="my-note"
      role="tabpanel"
      aria-labelledby="my-note-tab"
      style="position: absolute; width: 100%"
    >
      <div class="d-flex flex-column h-100">
        <div class="resizable-component bili-note">
          <div class="note-drag-bar drag-el">
            <div class="status-bar">
              <div class="status-bar--content status-bar--info">
                <!---->
                <!---->
                <span class="text" v-if="ms_isNoteFetched">
                  <span class="text-msg">
                    <template v-if="ms_isNoteSaved">
                      {{ ms_isSaveImmediately ? '' : '自动' }}保存成功
                    </template>
                    <template v-if="ms_isNoteSaving">
                      {{ ms_isSaveImmediately ? '' : '自动' }}保存中
                    </template>
                    <template v-if="!ms_isNoteSaving && !ms_isNoteSaved">
                      {{ '笔记内容加载完成' }}
                    </template>
                  </span>
                  <span v-show="ms_isNoteSaved">
                    {{ ms_dateNoteSaved }}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="notepad flex-grow-1 h-100">
          <textarea
            style="position: absolute; top: 28px; bottom: 0; width: 100%"
            v-model="noteContent"
            @input="saveNote"
            :readonly="!editable"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import { NoteContentModelMixin } from '@/mixins/Note/Content/model';

export default {
  name: 'plain-note-content',

  mixins: [NoteContentModelMixin],

  props: {
    value: {
      type: String,
      default: () => '',
    },

    typeOfEditor: {
      type: String,
      default: () => 'EXERCISE_NOTE',
    },

    editable: {
      type: Boolean,
      default: () => true,
    },
  },

  data() {
    return {
      prevValue: '',
    };
  },

  computed: {
    ...mapState('Mixins/Note', {
      ms_isNoteFetched: 'isNoteFetched',
      ms_isNoteSaving: 'isNoteSaving',
      ms_isNoteSaved: 'isNoteSaved',
      ms_dateNoteSaved: 'dateNoteSaved',
      ms_isSaveImmediately: 'isSaveImmediately',
    }),
  },

  watch: {
    value(v) {
      if (this.prevValue !== v) {
        this.prevValue = v;
        this.noteContent = v;
      }
    },
  },

  methods: {
    handleInputNoteContent() {
      this.prevValue = this.noteContent;
      this.$emit('input', this.noteContent);
    },

    handleSave() {
      this.$emit('save', { isSaveImmediately: false });
    },

    saveNote() {
      this.handleInputNoteContent();
      this.handleSave();
    },
  },

  created() {
    if (this.value) {
      this.prevValue = this.value;
      this.noteContent = this.value;
    }
  },
};
</script>
<style scoped lang="scss">
.resizable-component.resizable-component {
  height: auto;
}
</style>
